export default "__VITE_ASSET__B7qZ5W9M__"